import type { NewTask } from "../types";

// A fresh new-task form. Call it each time so one draft cannot leak into the next.
export function emptyNewTask(): NewTask {
  return {
    title: "",
    list_id: null,
    priority: 4,
    description: "",
    scheduled_date: null,
    scheduled_time: null,
    deadline_date: null,
    duration: null,
    subtasks: [],
    tag_ids: [],
    links: [],
  };
}
